import React, { useMemo, useState, useEffect } from 'react';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useAccessRoleUIContext } from '../../AccessRoleUIContext';
import { initialFilter } from '../../AccessRoleUIHelpers';
import * as BranchReq from '../../../../_redux/branchs/branchCrud'
import * as BankReq from '../../../../_redux/bank/bankCrud'

const prepareFilter = (queryParams, values) => {
	const { name } = values;
	const newQueryParams = { ...queryParams };
	const filter = {};

	//add to Object filter
	filter.name = name ?? '';
	newQueryParams.filter = filter;
	return newQueryParams;
};

export const AccessRoleFilter = ({ listLoading }) => {
	// AccessRole UI Context
	const accessRoleUIContext = useAccessRoleUIContext();
	const accessRoleUIProps = useMemo(() => {
		return {
			setQueryParams: accessRoleUIContext.setQueryParams,
			queryParams: accessRoleUIContext.queryParams,
			filterType: accessRoleUIContext.filterType,
		};
	}, [accessRoleUIContext]);

	const applyFilter = (values) => {
		const newQueryParams = prepareFilter(accessRoleUIProps.queryParams, values);
		if (!isEqual(newQueryParams, accessRoleUIProps.queryParams)) {
			newQueryParams.pageNumber = 1;
			accessRoleUIProps.setQueryParams(newQueryParams);
		}
	};


	return (
		<Formik initialValues={initialFilter.filter} onSubmit={(values) => {
			applyFilter(values);
		}}
		>{({ values, handleSubmit, handleBlur, setFieldValue }) => (
			<form onSubmit={handleSubmit} className="form form-label-right">
				<div className="form-group row">
					<div className="col-lg-4">
						<input
							type="text"
							className="form-control"
							name="name"
							placeholder="Search"
							onBlur={handleBlur}
							value={values.name}
							onChange={(e) => {
								setFieldValue('name', e.target.value);
								handleSubmit();
							}}
						/>
						<small className="form-text text-muted">
							<b>Cari</b> Berdasarkan Nama Opsi
						</small>
					</div>
				</div>
			</form>
		)}
		</Formik>

	);
};

